import SalesCredit from './SalesCredit';
import { EntityType } from '../../../@types/entityTypes';
import SalesReturnNoteReportMutation from '../../mutations/salesLedger/SalesReturnNoteReportMutation.graphql';
import SalesReturnNotesReportMutation from '../../mutations/salesLedger/SalesReturnNotesReportMutation.graphql';
import { printFunctions } from '../../../actions/salesLedger/SalesReturnNotePrintFunctions';
import { ReportType } from '../../schema/p4types';
import { customerDocument } from '../../../utils/mailMergeFields';

const SalesReturnNoteDocument: EntityType = {
  ...SalesCredit,
  printFunctions: printFunctions,
  generate: SalesReturnNoteReportMutation,
  generateRange: SalesReturnNotesReportMutation,
  configuration: {
    title: 'Return Note',
    field: 'salesReturnNoteDocumentDefault',
    reportType: ReportType.SalesReturnNote,
    customerField: 'customerSalesReturnNoteDocumentDefault', // not in use
    receiveFlag: 'receiveReturnNoteDocuments',
  },
  title: 'Return Orders',
  mergeFields: [
    ...customerDocument,
    {
      key: 'orderReference',
      text: 'Order Reference',
    },
    {
      key: 'salesOrderNumber',
      text: 'Sales Order Number',
    },
  ],
};

export default SalesReturnNoteDocument;
